import type { PaletteOptions } from '@mui/material/styles';

import type { ThemeColors } from './colors';

/**
 * Maps a resolved color set onto the MUI palette. Nested groups are copied so
 * the shared color sets are never handed to MUI by reference.
 */
export const createPalette = (colors: ThemeColors): PaletteOptions => ({
  mode: colors.mode,
  primary: { ...colors.primary },
  secondary: { ...colors.secondary },
  background: { ...colors.background },
  text: { ...colors.text },
  danger: { ...colors.danger },
  existingInterest: { ...colors.existingInterest },
  contracting: { ...colors.contracting },
  executed: { ...colors.executed },
  ghostWhite: { main: colors.ghostWhite },
  productType: { ...colors.productType },
  bid: { main: colors.bid },
  offer: { main: colors.offer },
  input: {
    background: { ...colors.input.background },
    border: {
      ...colors.input.border,
      focused: colors.primary.main,
    },
    placeholder: { main: colors.input.placeholder },
    label: { main: colors.ghostWhite },
  },
  ...colors.paletteOverrides,
});
